/**
 * useRosterProfile.ts
 *
 * React Query hook for fetching the current user's roster profile.
 * NOT synced from Keystone Platform — this file does not exist in Keystone,
 * so update.sh will never overwrite it (sync only copies FROM Keystone;
 * files absent in Keystone are left untouched in EQuIP Services).
 *
 * MAINT-01: Hook lives here to avoid regression via update.sh.
 *
 * staleTime: Infinity — roster role assignment is stable within a browser session.
 * No need to re-fetch on tab focus or after stale window return.
 */

import { useQuery } from '@tanstack/react-query'
import { getRosterProfile } from '@/services/equipApiExtras'
import type { RosterProfile } from '@/lib/equip-extras'

export function useRosterProfile() {
  return useQuery<RosterProfile>({
    queryKey: ['equip', 'roster-profile', 'me'],
    queryFn: getRosterProfile,
    staleTime: Infinity,
  })
}
